import Vue from 'vue';
import DictWebsiteFooter from '@webfront-components-vue/dict-website-footer';
import '@webfront-components-vue/dict-website-footer/dist/style.css';
import VipCenter from '@webfront-components-vue/vue-vip-center';
import '@webfront-components-vue/vue-vip-center/dist/style.css';
import {
  Input, Form, FormItem, InfiniteScroll,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Toast from '@/components/common/toast/index';
import CPopUp from './components/common/CPopUp/index';

import App from './App.vue';
import router from './router';
import '@/assets/css/reset.css';
import '@/style/vip.styl';
import '@/style/pc.styl';
import '@/style/font.styl';
import 'uikibrary/dist/UIKibrary.css';

Vue.config.productionTip = false;
Vue
  .use(VipCenter)
  .use(DictWebsiteFooter)
  .use(Input).use(Toast)
  .use(CPopUp)
  .use(Form)
  .use(FormItem)
  .use(InfiniteScroll);
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
